'use strict'

import Portraits from "./components/Portraits"
import AddClassIsAnimStart from "./components/AddClassIsAnimStart"
import PopIn from "./components/Popin";
import animLottie from "./components/AnimLottie"
import addOrRemoveClasListIsVisibleToScrollPosition from "./components/AddClassListIsVisible"


const main = {
    init: function() {

    
    //    debugger;

        // animation des titres
        let titles = document.querySelectorAll(".section--title, .section--paragraphe, .section--address, .section--titleMid, .section--resume .text li")
        let animTitlesHome = new AddClassIsAnimStart(titles)
        
        //INIT()
        // this.signatureConsole() //met une signature d'Havas Digital Factory en console 


        this.animLottieHomePage() // anims lottie Home
        // Portraits.init() //création de grille
        animTitlesHome.anime() //Animation des titres au scroll

        this.scrollEvents() //Gestion de l'apparition du logo + "scroll" au scroll
        this.resizeEvents() //Gestion des resizes

        //POPINS
        let portraits = document.querySelectorAll(".portraits--people .people")
        this.checkURLToOpenPopIn(portraits) // ouvre la popin correspondante à l'URL
        this.launchPopIn(portraits) // ouvre la popin au clic sur les portraits 

        //special rules
        window.addEventListener("load",()=>{
            this.rulesForIos()
        })

        main.menu.init();
       





    },
    signatureConsole: function() {
        console.log("%cHavas Digital Factory", 'background: #ff1e2f; color: white; padding:10px;');
        console.log("%chttps://havasdigitalfactory.com", 'background: black; color: #333; padding:10px;');
    
    },
    animLottieHomePage: function (){
        //creation des animations Lottie de la home
        //animLottie(container : Array, json link : Path)
        let animationsHome= [
            {
                container: '.section_01 .section--animation',
                path: 'slide-01/slide-01-light.json'
            },
            {
                container: '.section_02 .section--animation',
                path: 'slide-02/slide-02-light.json'
            },
            {   container: '.section_03 .section--animation',
                path: 'slide-03/slide-03-light.json'
            },
            {   container: '.section_04 .section--animationFd',
                path: 'slide-04/slide-04-fond.json'
            },
            {   container: '.section_04 .section--animation',
                path: 'slide-04/slide-04-light.json'
            },
            {   container: '.section_05 .section--animation',
                path: 'slide-05/slide-05-light.json'
            },
            {   container: '.section_06 .section--animation',
                path: 'slide-06/slide-06-light.json'
            },
            {   container: '.section_07 .section--animation',
                path: 'slide-07/slide-07-light.json'
            },
            {   container: '.section_07 .section--animationTab',
                path: 'slide-07/slide-07-tab-light.json'
            },
            {   container: '.section_08 .section--animation',
                path: 'slide-08/slide-08-light.json'
            },
        ]

        for(let animation in animationsHome){
            animLottie(animationsHome[animation].container, animationsHome[animation].path)
        }




     
    },
    seeAnimLottieToScroll: {
        observer: "",
        anime: function(elements) {
            observer = new IntersectionObserver(this.action, {threshold: [0, 0.5]})

            for (let element of this.elements) {
                this.prepare(element)
                observer.observe(element)
            }
        },
        prepare: function(item) {
           item.style.display= "none"
        },
        
        action: function (items) {
            items.forEach((item) => {
                if (item.intersectionRatio > 0.2){ 
                    item.target.style.display = "block"
                    //seeAnimLottieToScroll.observer.unobserve()
                }
            })
        }    
    },
    resizeEvents: function() {
        // Evenmenent au resize de la page
        let resizeIt;
        window.addEventListener("resize", function() {
            clearTimeout(resizeIt);
            resizeIt = setTimeout(
                function(){
                    // Portraits.init() 
                } 
            , 25);
        })
    },
    scrollEvents: function() {
        //gestion des éléments au scroll
        //Dispartiion du Logo et de l'élements scroll
        const scrollElement =  document.querySelector(".scroll");
        const sectionPortraitsEl = document.querySelector(".portraits");
        const section02 = document.querySelector(".section_02");
        const logo = document.querySelector(".header--logo");
        
        //check au load si les éléments sont a afficher
        checkIfItIsVisible()
        function checkIfItIsVisible() {
            addOrRemoveClasListIsVisibleToScrollPosition(scrollElement, sectionPortraitsEl, 20);
            // addOrRemoveClasListIsVisibleToScrollPosition(logo, section02, 0);
        }

        // Evenement au scroll de la page
        window.document.addEventListener("scroll", function() {
            let scrollIt
            clearTimeout(scrollIt)
            scrollIt = setTimeout( checkIfItIsVisible() , 250)
        })
    },
    checkURLToOpenPopIn: function(portraits) {
        // Gestion des popins suivant les URLS rentrantes
        // si /#nom-prenom-ID.html on revoit sur la home avec l'ouverture de la popin correspondante un slug-name / ID
        let hash = window.location.hash
        // recupere le slugname dans l'url
        let slugName = hash.slice(1,hash.length)
        //on récupère l'ID
        let found = slugName.split("-")
        let id = found[found.length-1]
        //check dans les portraits
        for(let portrait of portraits){
            //si portraits est dans la liste, on affiche la popin
            if(portrait.dataset.id === id){
                let myPopIn = new PopIn(portrait);
                myPopIn.create()
            }  
        }
    },
    launchPopIn: function(portraits) {
        //creation de la popin et chargement du contenu            
        for(let portrait of portraits){
            portrait.addEventListener("click", function(){
                if(window.innerWidth < 768){
                    Portraits.infoPortraitMobile(this.parentNode);
                }
                else {
                    let myPopIn = new PopIn(this);
                    myPopIn.create()
                }
            });
        } 
    },
    rulesForIos: function(){

        let section = document.querySelector(".section");
        let iPad = navigator.userAgent.match(/(iPad)/g);
        if(section) {
            section.style.minHeight = "100vh";

            if(iPad && section.style.minHeight === '100vh'){
                    section.style.minHeight = "96.5vh";
                    // window.alert(iPad)
            }
        }
    },

    menu: {
        menuContent: document.querySelector(".header--menu"),
        btnMenu: document.querySelector(".header--button-menu"),
        footer: document.querySelector(".footer--contact"),
        init : function(){
            this.menuContent.classList.add("isHidden");

            //MENU
            let buttonMenu = document.querySelector(".header--button-menu");
            let items = document.querySelectorAll(".menu--items"); 
        
            buttonMenu.addEventListener("click", function(){ main.menu.openCloseMenu() })
            let linksmenu = document.querySelectorAll(".menu--items a");
            
            //Liens vers les ancres du menu
            
            Object.keys(linksmenu).forEach( (key) => {
                let item = linksmenu[key];
                item.addEventListener("click", function(e){
                    main.menu.openCloseMenu();

                    main.menu.footer.classList.remove("footer--big");
                    let target = this.hash.slice(1).toString();
                    let cible = document.querySelector("#" + target);
                    cible.scrollIntoView({ top:-400, behavior: 'smooth'  });
                    e.preventDefault();
                })
                
            })
            
            //agrandi le footer
            let contactLink = document.querySelector(".menu--items:last-child");
            contactLink.addEventListener("click", ()=>{ main.menu.openFooter()});
        },
        openCloseMenu: function(){       
           
            if( this.menuContent.classList.contains('isHidden') ){
                this.menuContent.classList.add("isVisible");
                this.menuContent.classList.remove("isHidden");

                // btn Menu
                this.btnMenu.classList.remove("open");
                this.btnMenu.classList.add("close");
             
            }

            else{
                this.menuContent.classList.remove("isVisible");
                this.menuContent.classList.add("isHidden");

                //btn Menu
                this.btnMenu.classList.add("open");
                this.btnMenu.classList.remove("close");
  
            }


        },
        openFooter : function(){
            this.footer.scrollIntoView({ top:-400, behavior: 'smooth'  });
            this.footer.classList.add("footer--big");
         }
    }
    
}

export default main


// WEBPACK FOOTER //
// ./src/scripts/main.js